/** @jsx jsx */
import { h, FunctionalComponent } from 'preact'
import { css, jsx } from '@emotion/core'

import GradeBacker from './GradeBacker'
import Trade from './Trade'
import { getIconStyles } from './icon.styles'
import { StylesObject } from '../../types/styles'

interface IconProps {
    icon: string
    fill: string
    iconClass?: StylesObject
}

const icons = {
    GradeBacker,
    Trade,
}

const IconFactory: FunctionalComponent<IconProps> = ({ icon, fill, iconClass, ...rest }) => {
    const iconStyles = getIconStyles(fill)
    if (!icons[icon]) throw new Error(`Invalid icon "${icon}" has been specified`)

    const I = icons[icon]

    return (
        <span
            css={css`
                ${iconStyles.icon} ${iconClass && iconClass}
            `}
        >
            <I fill={!['dark', 'light', 'link'].includes(fill) ? fill : null} {...rest} />
        </span>
    )
}

IconFactory.defaultProps = {
    fill: '',
    iconClass: {},
}

export default IconFactory
